<!--
//================================================================================
// ID:-
// ProjectName: 都営住宅募集オンライン申請
// SystemName: 都営住宅募集オンラインシステム
// JavaScriptName:SystemError
//
// <<Modification History>>
// Version  | Date       | Updated By            | Content
// ---------+------------+-----------------------+--------------------------------
// 01.00.00 | 2021/07/09 | 富士通株式会社         | 新規作成
//================================================================================
-->
<template>
	<main>
		<div class="contents__block--notexist_menu">
			<div class="contents__wrap--scroll_vertical">
				<div class="contents__view--bg_gray">
					<!-- エラーメッセージ -->
					<error-message />
					<div class="error__area-btn">
						<!-- ログインへ -->
						<input
							type="button"
							class="contents__btn--normal"
							value="ログインへ"
							v-on:click="clickToLogin">
					</div>
				</div>
			</div>
		</div>
	</main>
</template>

<script>
import ErrorMessage from '@/components/ErrorMessage.vue';
import { STORE_VIEW_PROGRESS, STORE_USER_CLEAR, STORE_DATA_DELETE_ALL, STORE_VIEW_CLEAR_PAGE, STORE_VIEW_CLEAR_VIEW_PARAMS } from '@/const/store.js';
import { co_doLogout } from '@/common/logoutEventUtility.js';
import { co_toTrans } from '@/common/screenUtility';

export default {
	components: {
		'error-message': ErrorMessage,
	},
	// 初期表示
	created: function() {

		// プログレスバーを非表示
		this.$store.commit(STORE_VIEW_PROGRESS, false);

		// 画面保持情報クリア
		this.$store.commit(STORE_DATA_DELETE_ALL);
		this.$store.commit(STORE_VIEW_CLEAR_PAGE);
		this.$store.commit(STORE_VIEW_CLEAR_VIEW_PARAMS);

		// ユーザ情報削除
		this.$store.commit(STORE_USER_CLEAR);

	},
	methods: {
		// ログイン処理
		clickToLogin: function () {
			// ログアウト実行
			co_doLogout();

			// ログインに遷移
			co_toTrans('BC001');
		}
	}
}
</script>

<style scoped>
.contents__block--notexist_menu {
	padding-top: 150px;
}
.error__area-btn {
	margin-top: 10px;
	text-align: center;
}

.contents__wrap--scroll_vertical {
	height: auto;
	overflow: visible;
}

</style>